import React from 'react'
import Modal from 'react-modal'
import { useMutation } from '@apollo/client'
import sendReminderEmail from '../mutations/send-reminder-email'
import { formatDate } from '../utils'

const className = {
  base: 'modal wide',
  afterOpen: 'modal-after-open',
  beforeClose: 'modal-before-close',
}

const overlayClassName = {
  base: 'overlay',
  afterOpen: 'overlay-after-open',
  beforeClose: 'overlay-before-close',
}

const SuccessMessage = ({ onCancel }) => {
  return (
    <div>
      <h2>Reminder Emails have been sent!</h2>
      <p>
        A reminder email has been sent to each student who has not yet submitted
        a reflection.
      </p>
      <button onClick={onCancel} className="close-button">
        Close Window
      </button>
    </div>
  )
}

const ReminderForm = ({ emailBody, handleSubmit, handleChange, question }) => {
  return (
    <div>
      <h2>Reminder email</h2>
      <p style={{ fontStyle: 'italic' }}>{question}</p>
      <form onSubmit={handleSubmit}>
        <div style={{ textAlign: 'left' }}>
          Instructor: You can personalize the text below with any specific
          instructions, etc.
        </div>
        <textarea value={emailBody} onChange={handleChange} />
        <button>Submit</button>
      </form>
    </div>
  )
}

function SendReminderModal(props) {
  const { assignment } = props
  const due = formatDate(props.assignment.dueAt, 'MM/DD/YYYY')

  const [isSubmitted, setIsSubmitted] = React.useState(false)
  const [link, setLink] = React.useState(
    `Link: [${assignment.question.text}](https://my.refleq.com/my-reflections/${assignment.project.id})`
  )
  const [emailBody, setEmailBody] = React.useState(
    `
Hi students:

Please submit your reflection to this question in the ${assignment.project.name}.  It has a due date of ${due}.

Thank you.

`
  )
  const [sendReminderEmailMutation] = useMutation(sendReminderEmail)
  const closeModal = () => {
    setIsSubmitted(false)
    props.onCancel()
  }

  const handleChange = (e) => {
    setEmailBody(e.target.value)
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    const { students, id } = props

    sendReminderEmailMutation({
      variables: {
        id: id,
        emailBody: addParagraphs(emailBody),
        link: link,
        studentIds: students.map((s) => s.id),
      },
    }).then(() => {
      setEmailBody('')
      setIsSubmitted(true)
    })
  }

  const addParagraphs = (emailBody) => {
    return emailBody.replace(/\n/g, '  \n')
  }
  const { isOpen, onCancel } = props

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onCancel}
      className={className}
      overlayClassName={overlayClassName}
    >
      <a className="close" onClick={closeModal}>
        Cancel
      </a>
      {isSubmitted ? (
        <SuccessMessage onCancel={closeModal} />
      ) : (
        <ReminderForm
          emailBody={emailBody}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          question={assignment.question.text}
        />
      )}
    </Modal>
  )
}

export default SendReminderModal
